import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import TransferSearchForm from "./TransferSearchForm";
import TransferResultCard from "./TransferResultCard";
import TransferQuoteVehicleCard from "./TransferQuoteVehicleCard";
import { useTransferSearch } from "../../../../context/TransferSearchContext";
import { computeEffectivePrice } from "../../../../services/TransferService";

const TransferSearch = () => {
	const navigate = useNavigate();
	const { resetSearchData } = useTransferSearch();
	const [results, setResults] = useState([]);
	const [quoteVehicles, setQuoteVehicles] = useState([]);
	const [searched, setSearched] = useState(false);

	// Landing on the search page should always start blank, even though the
	// context otherwise carries search data forward into the booking flow.
	useEffect(() => {
		resetSearchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function handleResults(result) {
		// A matched route returns Book_now (bookable with pricing). No matching route
		// instead returns Get_Quote — every vehicle, no pricing, so agents can still
		// pick one and request a manual quote instead of hitting a dead end.
		const bookNow = Array.isArray(result?.Book_now) ? result.Book_now : [];
		const getQuote = Array.isArray(result?.Get_Quote) ? result.Get_Quote : [];
		// Corrections doc: sort search results by price, low to high.
		const sortedBookNow = [...bookNow].sort(
			(a, b) => computeEffectivePrice(a).effective - computeEffectivePrice(b).effective
		);
		setResults(sortedBookNow);
		setQuoteVehicles(getQuote);
		setSearched(true);
	}

	function handleSearchStart() {
		setSearched(false);
	}

	function handleBookNow(transferData) {
		navigate(`/transfer-booking`, { state: { transferData } });
	}

	function handleRequestQuote(transferData) {
		navigate(`/transfer-quote-request`, { state: { transferData } });
	}

	return (
		<div className="transfer-flow">
			<PageTitle activeMenu="Transfer Search" motherMenu="Dashboard" />
			<div className="row">
				<div className="col-xl-12">
					<TransferSearchForm onResults={handleResults} onSearchStart={handleSearchStart} />
				</div>
			</div>

			{searched && (
				<div className="row mt-4">
					<div className="col-xl-12">
						{results.length > 0 ? (
							<>
								<h5 className="mb-3">
									Showing {results.length} result{results.length > 1 ? "s" : ""}
								</h5>
								{results.map((transferData) => (
									<TransferResultCard
										key={transferData.vehicle_id}
										transferData={transferData}
										onBookNow={() => handleBookNow(transferData)}
									/>
								))}
							</>
						) : quoteVehicles.length > 0 ? (
							<>
								<h5 className="mb-3">
									We don't have a fixed rate for this route yet — pick a vehicle to request a quote
								</h5>
								{quoteVehicles.map((transferData) => (
									<TransferQuoteVehicleCard
										key={transferData.vehicle_id}
										transferData={transferData}
										onRequestQuote={() => handleRequestQuote(transferData)}
									/>
								))}
							</>
						) : (
							<div className="card">
								<div className="card-body text-center text-muted py-5">
									No transfers found for this route. Try a different search.
								</div>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default TransferSearch;
